import dayjs from "dayjs";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";
import { IGetAllTreinamentoFuncionarioTercInstrutorUseCase } from "../../../presentation/useCases/read/get_all_treinamento_funcionario_terc_instrutor_use_case";
import { TreinamentoFuncionarioInstrutor } from "../../../../rh/domain/models/treinamento_funcionario_instrutor";


export class GetAllTreinamentoFuncionarioTercInstrutorUseCase implements IGetAllTreinamentoFuncionarioTercInstrutorUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) { }

  async getAllTreinamentoFuncionarioTercInstrutor(
    data: Date,
  ): Promise<TreinamentoFuncionarioInstrutor[]> {
    return this.repository.getAllTreinamentoFuncionarioTercInstrutor(dayjs(data).format('YYYYMMDD'));
  }
}
